module.exports = __webpack_public_path__ + "static/img/3.f2c4b4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/3.png
// module id = /iCG
// module chunks = 0